type RoleLike = {
    id: string;
    name: string;
    roleKey?: string | null;
    isSystem?: boolean;
};

const normalizeRoleKey = (role: string | null | undefined) => String(role || '').trim().toUpperCase();

const PROTECTED_ASSIGNMENT_ROLE_KEYS = new Set(['OWNER']);
const PROTECTED_REPLACEMENT_ROLE_KEYS = new Set(['OWNER']);
const REPLACEMENT_SYSTEM_ROLE_KEYS = new Set(['ADMIN', 'BILLING', 'MEMBER']);

const getRoleOptionKey = (role: RoleLike) => normalizeRoleKey(role.roleKey || role.name || role.id);

export const isOwnerRoleOption = (role: RoleLike) => getRoleOptionKey(role) === 'OWNER';

export const isDeletionReplacementRoleOption = (
    role: RoleLike,
    roleToDelete?: RoleLike
) => {
    const roleKey = getRoleOptionKey(role);

    return role.id !== roleToDelete?.id
        && !PROTECTED_REPLACEMENT_ROLE_KEYS.has(roleKey)
        && (REPLACEMENT_SYSTEM_ROLE_KEYS.has(roleKey) || !role.isSystem);
};

export const getDeletionReplacementRoleOptions = <T extends RoleLike>(
    roles: T[],
    roleToDelete: RoleLike
) => roles.filter(role => isDeletionReplacementRoleOption(role, roleToDelete));

export const getMemberAssignmentRoleOptions = <T extends RoleLike>(
    roles: T[],
    allowCustomRoles: boolean
) => {
    return roles
        .filter(role => allowCustomRoles || role.isSystem)
        .filter(role => {
            const roleKey = getRoleOptionKey(role);
            if (PROTECTED_ASSIGNMENT_ROLE_KEYS.has(roleKey)) return false;
            return true;
        });
};
